<template>
    <div class="nav">
        <img :src="`https://4d-ai.chat/img/${$t('img.logo')}.png`" @click="goAnchor(`/`)">
        <div class="company" @click="goAnchor(`/`)">{{ $t('nav.companyName') }}</div>
        <div style="flex: 1;"></div>
        <div :class="['link', { 'active': path == item }]" v-for="(item, index) in list" @click="goAnchor(item)">
            {{ $t(`nav.nav${index + 1}`) }}
            <div class="line" v-if="path == item"></div>
        </div>
        <div class="link" @click="changeLanguage">{{ $t('language.name') }}</div>
    </div>
</template>
<script>
export default {
    data() {
        return {
            path: this.defaultPath,
            list: [`/`, `/aboutUs`, `/successCases`, `/companyNews`, `/businessCooperation`],
        }
    },
    mounted() {

    },
    props: {
        defaultPath: {
            default: `/`
        }
    },
    methods: {
        goAnchor(item) {
            if (this.path == item) {
                return
            }
            this.path = item
            this.$router.push(item)
        },
        changeLanguage() {
            this.$i18n.locale = this.$i18n.locale === 'zh' ? 'en' : 'zh'
            localStorage.setItem('languageSet', this.$i18n.locale)
        },
    }
}
</script>
<style scoped>
@media (max-width: 768px) {
    .nav {
        min-height: 40px !important;
        line-height: 40px !important;
        padding: 0 10px !important;
    }

    img {
        width: 40px !important;
        cursor: pointer;
    }

    .company {
        font-size: 12px !important;
    }

    .link {
        font-size: 12px !important;
    }

    .line {
        width: 16px !important;
        height: 2px !important;
    }
}
</style>
<style scoped lang="less">
.nav {
    box-shadow: 0 2px 10px #0000001a;
    height: 64px;
    padding: 0 212px;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    background-color: #28408e;
    position: fixed;
    top: 0;
    width: 100%;
    color: #fff;
    z-index: 3;
    line-height: 64px;

    img {
        width: 58px;
        cursor: pointer;
    }

    .link:hover {
        color: #fff;
    }

    .active {
        color: #fff !important;
    }

    .link {
        height: 100%;
        font-size: 16px;
        margin-left: 32px;
        cursor: pointer;
        color: #FFFFFFB3;
        text-decoration: none;
        position: relative;

        .line {
            position: absolute;
            bottom: 15px;
            left: 50%;
            transform: translateX(-50%);
            width: 26px;
            height: 2px;
            background-color: #fff;
        }
    }

    .company {
        font-size: 24px;
        font-weight: 600;
        cursor: pointer;
    }
}
</style>